import { Injectable } from '@angular/core';
import { Zone } from '../models/zone';
import { ZoneService } from './zone.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Sensor } from '../models/sensor';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public zones?: Zone[];

  private sharedZones = new BehaviorSubject<any>(null);

  private sharedZone = new BehaviorSubject<Zone>(null);

  private sharedCompany = new BehaviorSubject<any>(null);

  private sharedCompanyId = new BehaviorSubject<any>(null);

  private sharedSensors = new BehaviorSubject<any>(null);

  get sharedZones$(): Observable<Zone> {
    return this.sharedZones.asObservable();
  }
  
  get sharedZone$(): Observable<Zone> {
    return this.sharedZone.asObservable();
  }

  get sharedCompany$(): Observable<any> {
    return this.sharedCompany.asObservable();
  }

  get sharedCompanyId$(): Observable<any> {
    return this.sharedCompanyId.asObservable();
  }

  get sharedSensors$(): Observable<any> {
    return this.sharedSensors.asObservable();
  }

  public updateZones(zone: any) {
    this.sharedZones.next(zone);
  }

  public updateZone(zone: Zone) {
    this.sharedZone.next(zone);
  }

  public updateSensors(sensors: any) {
    this.sharedSensors.next(sensors);
  }

  public updateCompany(company: any) {
    this.sharedCompany.next(company);
  }

  public updateCompanyId(company: any) {
    this.sharedCompanyId.next(company);
  }

  private sharedSensor = new BehaviorSubject<Sensor>(null);

  get sharedSensor$(): Observable<Sensor> {
    return this.sharedSensor.asObservable();
  }

  public updateSensor(sensor: Sensor) {
    this.sharedSensor.next(sensor);
  }


  constructor(private zoneService: ZoneService) { }

  public getZoneById(zoneId: string): Zone {
    return this.zones?.find(x => x._id === zoneId);
  }

}
